import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Grid from '@material-ui/core/Grid';
import { useStyles } from './TakisSkeleton.styles';

const TakisProductHeroSkeleton = () => {
    const classes = useStyles();
      return (
        <>
        <Grid container spacing={0} className={classes.productDetailHero}>
          <div className={classes.backgroundContainer}>
          </div>
          <Grid item xs={12} lg={6}>
            <Skeleton variant="rect" className={classes.productHeroImage}/>
          </Grid>
          <Grid item xs={12} lg={6}>
            <div className={`${classes.productDetailContainer}`}>
              <Skeleton variant="rect" className={classes.product_hero_heading}/>
              <Skeleton variant="rect" className={classes.product_hero_text}/>
              <Skeleton variant="rect" className={classes.product_hero_button}/>
            </div>
            <Skeleton variant="rect" className={classes.product_hero_decoration}/>
          </Grid>
        </Grid>
        </>
      );
}

export default TakisProductHeroSkeleton;
